import React from 'react';
import { useOrderFlowStore } from '../../../store/orderFlowStore';
import { useTranslations } from '../../../hooks/useTranslations';
import { useCustomerInfo } from '../../../hooks/useCustomerInfo';
import { ProductPreview } from '../components/ProductPreview';
import HelpButton from '../../../components/atoms/HelpButton/HelpButton';

import { LotSize } from '../../../types/orderFlow';
import styles from './SelectLotSize.module.scss';

export const SelectLotSize: React.FC = () => {
  const t = useTranslations();
  const customerInfo = useCustomerInfo();
  const { 
    lotSize, 
    setLotSize, 
    currentProduct,
    productType,
    beanType,
    packageType,
    selectedBean,
    sugarConcentration,
    needsInnerDesign,
    needsFrontLabel,
    needsOuterBox,
    needsOuterBoxDesign,
    needsBackLabel,
    totalPrice,
    basePrice,
    optionPrices,
    calculateTotalPrice
  } = useOrderFlowStore();

  // 商品タイプ別のロット数選択肢を取得
  const getLotOptions = (): Array<{ value: LotSize; label: string; description: string }> => {
    switch (productType) {
      case 'freeze-dried':
        return [
          { value: '100', label: t.selectLotSize_pieces100, description: t.selectLotSize_lotDescription100 },
          { value: '250', label: t.selectLotSize_pieces250, description: t.selectLotSize_lotDescription250 },
          { value: '500', label: t.selectLotSize_pieces500, description: t.selectLotSize_lotDescription500 },
          { value: '1000', label: t.selectLotSize_pieces1000, description: t.selectLotSize_lotDescription1000 }
        ];
      case 'liquid-concentrate':
      case 'straight-coffee':
        return [
          { value: '60', label: t.selectLotSize_pieces60, description: t.selectLotSize_lotDescription60 },
          { value: '180', label: t.selectLotSize_pieces180, description: t.selectLotSize_lotDescription180 },
          { value: '540', label: t.selectLotSize_pieces540, description: t.selectLotSize_lotDescription540 },
          { value: '1080', label: t.selectLotSize_pieces1080, description: t.selectLotSize_lotDescription1080 }
        ];
      default:
        return [
          { value: '100', label: t.selectLotSize_pieces100, description: t.selectLotSize_defaultDescription }
        ];
    }
  };

  const lotOptions = getLotOptions();

  const handleLotSelect = (selectedLot: LotSize) => {
    setLotSize(selectedLot);
    // ロット選択時に価格を再計算
    calculateTotalPrice();
  };



  return (
    <div className={styles.selectLotSize}>
      <div className={styles.contentContainer}>
        {/* プレビュー画像エリア */}
        <div className={styles.previewSection}>
          <div className={styles.previewContainer}>
            <ProductPreview />
          </div>
        </div>

        {/* ロット数選択セクション */}
        <div className={styles.lotSelectionSection}>
          <div className={styles.sectionHeader}>
            <h2 className={styles.sectionTitle}>{t.selectLotSize_title}</h2>
            <HelpButton helpText={t.help_selectLotSize || ''} />
          </div>

          <div className={styles.lotSelector}>
            <select 
              className={styles.lotSelect}
              value={lotSize || ''}
              onChange={(e) => handleLotSelect(e.target.value as LotSize)}
              aria-label={t.selectLotSize_selectLabel}
            >
              <option value="" disabled>{t.selectLotSize_selectPlaceholder}</option>
              {lotOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          {/* {lotSize && (
            <div className={styles.lotDescription}>
              <p>{lotOptions.find(opt => opt.value === lotSize)?.description}</p>
            </div>
          )} */}

          <div className={styles.lotNote}>
            <p>{t.selectLotSize_manufacturingNote}</p>
          </div>
        </div>
      </div>

      {/* 保存機能の説明 - ログイン済みかつ承認済みのユーザーのみ表示 */}
      {customerInfo.canOrder && (
        <div className={styles.saveNotice}>
          <p>{t.selectLotSize_saveNotice1}</p>
          <p>{t.selectLotSize_saveNotice2}</p>
        </div>
      )}


    </div>
  );
}; 